module.exports = __webpack_public_path__ + "img/delete.3f78cf2f.svg";